export default __webpack_public_path__ + "static/media/Affogato-Cover.620a8611.png";